import React, { useEffect, useState } from 'react';

import Cookies from 'js-cookie';
import { END } from 'redux-saga';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { GetServerSideProps } from 'next';
import { useSelector } from 'react-redux';

import {
  IBannerProps,
  INITIAL_STATE_FILTERS,
  IShowCaseState,
  loadShowCaseData,
  resetFilters,
} from 'store/modules/showcase';
import { objectIsEmpty } from 'utils/objectEmpty';
import { IState, SagaStore, storeWrapper } from 'store';

import SEO from 'components/common/SEO';
import Layout from 'components/Layout';
import { Showcase } from 'components/pages/Showcase';
const BannersFull = dynamic(
  () => import('components/common/Templates/Carousel/BannersFull'),
);
const Error404 = dynamic(() => import('components/common/Error404'));

import * as S from 'styles/pages/App/Showcase';

interface IShowcase {
  permaLink: string;
}

export default function ShowcaseBrand({ permaLink }: IShowcase) {
  const router = useRouter();

  const { showcase, banners } = useSelector<IState, IShowCaseState>(
    state => state.showcase,
  );

  const [windowWidth, setWindowWidth] = useState('web');

  useEffect(() => {
    if (!router.query?.campanha) {
      Cookies.remove('@SportsNutrition:campanha');
    }
  }, [router]);

  function resizeWindow() {
    if (typeof window !== 'undefined') {
      if (window.innerWidth > 1200) {
        setWindowWidth('web');
      } else {
        setWindowWidth('mobile');
      }
    }
  }

  useEffect(() => {
    resizeWindow();
  }, []);

  if (typeof window !== 'undefined') {
    window.addEventListener('resize', resizeWindow);
  }

  if (objectIsEmpty(showcase)) {
    return (
      <Layout>
        <SEO />
        <Error404 />
      </Layout>
    );
  }

  return (
    <Layout>
      <SEO
        title={showcase.titulo}
        description={showcase.seo_Descricao}
        keywords={showcase.seo_PalavrasChaves}
      >
        <meta name="cs:page" content="categorias" />
      </SEO>

      <S.Container>
        {banners?.filter(banner => banner.tipo === 'FULL').length > 0 && (
          <BannersFull
            banners={banners?.filter(banner => banner.tipo === 'FULL')}
          />
        )}

        {windowWidth === 'mobile' &&
          banners?.filter(banner => banner.tipo === 'VITRINE_LATERAL').length >
            0 && (
            <BannersFull
              banners={banners?.filter(
                banner => banner.tipo === 'VITRINE_LATERAL',
              )}
            />
          )}

        <Showcase permaLink={permaLink} />
      </S.Container>
    </Layout>
  );
}

export const getServerSideProps: GetServerSideProps =
  storeWrapper.getServerSideProps(async ({ params, store, res }) => {
    res.setHeader(
      'Cache-Control',
      'public, s-maxage=600, stale-while-revalidate=600',
    );

    const { slug } = params;

    store.dispatch(resetFilters());

    store.dispatch(
      loadShowCaseData({
        permaLink: `vitrine/marca/${slug}`,
        routeParams: { ...INITIAL_STATE_FILTERS },
      }),
    );
    store.dispatch(END);

    await (store as SagaStore).sagaTask.toPromise();

    return {
      props: {
        permaLink: `vitrine/marca/${slug}`,
      },
    };
  });
